'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = require('../../lib/Input');

var _Input2 = _interopRequireDefault(_Input);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'fieldContainer': 'Input__fieldContainer___2RAwF',
  'inputContainer': 'Input__inputContainer___6KIo_',
  'error': 'Input__error___1jTWl',
  'disabled': 'Input__disabled___1WPa9',
  'inputPlaceholderContainer': 'Input__inputPlaceholderContainer___3om7J',
  'horizontalSpacingSmall': 'Input__horizontalSpacingSmall___3zuC5',
  'animatedPlaceholderStart': 'Input__animatedPlaceholderStart___3LA4D',
  'animatedPlaceholderEnd': 'Input__animatedPlaceholderEnd___1mds-',
  'heightSmall': 'Input__heightSmall___ZMTIb',
  'heightDefault': 'Input__heightDefault___3Oyz0',
  'heightMedium': 'Input__heightMedium___1ZymC',
  'iconContainer': 'Input__iconContainer___1xret',
  'iconSpacingSmall': 'Input__iconSpacingSmall___x8uZR',
  'icon': 'Input__icon___2x0vJ',
  'errorMessage': 'Input__errorMessage____Xou_',
  'errorMessageRight': 'Input__errorMessageRight___3s91s',
  'label': 'Input__label___2_a4i',
  'bootstrapPadding': 'Input__bootstrapPadding___3rgDQ',
  'readOnlyContainer': 'Input__readOnlyContainer___3MxeP',
  'withLeftDecorator': 'Input__withLeftDecorator___1LUlg',
  'withRightDecorator': 'Input__withRightDecorator___3YhZZ',
  'heightLarge': 'Input__heightLarge___utsX-',
  'withAnimatedPlaceholder': 'Input__withAnimatedPlaceholder___3q8j0',
  'input': 'Input__input___bRf3p',
  'decorator': 'Input__decorator___1aG4Q',
  'errorIcon': 'Input__errorIcon___13Rs9 Input__icon___2x0vJ',
  'validatedIcon': 'Input__validatedIcon___1O9r6 Input__icon___2x0vJ',
  'readOnlyInput': 'Input__readOnlyInput___2NgAi',
  'inputFocus': 'Input__inputFocus___2TxFP'
};

var DefaultInput = (0, _mergeThemeHoc2.default)(style)(_Input2.default);
DefaultInput.displayName = 'DefaultInput';
exports.default = DefaultInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Input/index.js
// module id = ./node_modules/dibs-elements/dist/Input/index.js
// module chunks = 4